"use strict";
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Impersonated = void 0;

var oauth2client_1 = require("./oauth2client");

var Impersonated =
/*#__PURE__*/
function (_oauth2client_1$OAuth) {
  _inherits(Impersonated, _oauth2client_1$OAuth);

  /**
   * Impersonated service account credentials.
   *
   * Create a new access token by impersonating another service account.
   *
   * Impersonated Credentials allowing credentials issued to a user or
   * service account to impersonate another. The source project using
   * Impersonated Credentials must enable the "IAMCredentials" API.
   * Also, the target service account must grant the orginating principal
   * the "Service Account Token Creator" IAM role.
   *
   * @param {object} options - The configuration object.
   * @param {object} [options.sourceClient] the source credential used as to
   * acquire the impersonated credentials.
   * @param {string} [options.targetPrincipal] the service account to
   * impersonate.
   * @param {string[]} [options.delegates] the chained list of delegates
   * required to grant the final access_token. If set, the sequence of
   * identities must have "Service Account Token Creator" capability granted to
   * the preceding identity. For example, if set to [serviceAccountB,
   * serviceAccountC], the sourceCredential must have the Token Creator role on
   * serviceAccountB. serviceAccountB must have the Token Creator on
   * serviceAccountC. Finally, C must have Token Creator on target_principal.
   * If left unset, sourceCredential must have that role on targetPrincipal.
   * @param {string[]} [options.targetScopes] scopes to request during the
   * authorization grant.
   * @param {number} [options.lifetime] number of seconds the delegated
   * credential should be valid for up to 3600 seconds by default, or 43,200
   * seconds by extending the token's lifetime, see:
   * https://cloud.google.com/iam/docs/creating-short-lived-service-account-credentials#sa-credentials-oauth
   * @param {string} [options.endpoint] api endpoint override.
   */
  function Impersonated() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Impersonated);

    var _a, _b, _c, _d, _e, _f;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Impersonated).call(this, options));
    _this.credentials = {
      expiry_date: 1,
      refresh_token: 'impersonated-placeholder'
    };
    _this.sourceClient = (_a = options.sourceClient) !== null && _a !== void 0 ? _a : new oauth2client_1.OAuth2Client();
    _this.targetPrincipal = (_b = options.targetPrincipal) !== null && _b !== void 0 ? _b : '';
    _this.delegates = (_c = options.delegates) !== null && _c !== void 0 ? _c : [];
    _this.targetScopes = (_d = options.targetScopes) !== null && _d !== void 0 ? _d : [];
    _this.lifetime = (_e = options.lifetime) !== null && _e !== void 0 ? _e : 3600;
    _this.endpoint = (_f = options.endpoint) !== null && _f !== void 0 ? _f : 'https://iamcredentials.googleapis.com';
    return _this;
  }
  /**
   * Refreshes the access token.
   * @param refreshToken Unused parameter
   */


  _createClass(Impersonated, [{
    key: "refreshToken",
    value: function refreshToken(_refreshToken) {
      var _a, _b, _c, _d, _e, _f, name, u, body, res, tokenResponse, status, message;

      return _regeneratorRuntime.async(function refreshToken$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _regeneratorRuntime.awrap(this.sourceClient.getAccessToken());

            case 3:
              name = 'projects/-/serviceAccounts/' + this.targetPrincipal;
              u = "".concat(this.endpoint, "/v1/").concat(name, ":generateAccessToken");
              body = {
                delegates: this.delegates,
                scope: this.targetScopes,
                lifetime: this.lifetime + 's'
              };
              _context.next = 8;
              return _regeneratorRuntime.awrap(this.sourceClient.request({
                url: u,
                data: body,
                method: 'POST'
              }));

            case 8:
              res = _context.sent;
              tokenResponse = res.data;
              this.credentials.access_token = tokenResponse.accessToken;
              this.credentials.expiry_date = Date.parse(tokenResponse.expireTime);
              return _context.abrupt("return", {
                tokens: this.credentials,
                res: res
              });

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              status = (_c = (_b = (_a = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.status;
              message = (_f = (_e = (_d = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f.message;

              if (!(status && message)) {
                _context.next = 24;
                break;
              }

              _context.t0.message = "".concat(status, ": unable to impersonate: ").concat(message);
              throw _context.t0;

            case 24:
              _context.t0.message = "unable to impersonate: ".concat(_context.t0);
              throw _context.t0;

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[0, 15]]);
    }
  }]);

  return Impersonated;
}(oauth2client_1.OAuth2Client);

exports.Impersonated = Impersonated;